import React from 'react';
import PropTypes from 'prop-types';
import { Heart, HeartFilled } from '@one-thd/sui-icons';

export const HeartIcon = ({ active }) => {
  return (
    active ? <HeartFilled data-testid="heart icon" className="slm-favorite-icon__heart-icon" />
      : <Heart data-testid="heart icon" color="primary" />
  );
};

HeartIcon.propTypes = {
  active: PropTypes.bool.isRequired
};
